"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableCurrenciesAdapterV2 = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _arrayIntersection = _interopRequireDefault(require("../core/utilities/arrayIntersection"));

var availableCurrenciesAdapter = function availableCurrenciesAdapter(_ref) {
  var merchandiseMap = _ref.merchandiseMap,
      customerCurrencyCode = _ref.customerCurrencyCode,
      itemConfigurations = _ref.itemConfigurations;

  // Customer currency code exists when a user has already purchased
  // one of our products in apollo. We want to lock them into that
  // curerncy and therefore we only return that value.
  if (customerCurrencyCode) {
    return [customerCurrencyCode];
  }

  var _getAvailableCurrencies = function _getAvailableCurrencies(_ref2) {
    var merchandiseId = _ref2.merchandiseId;
    var merchandiseItem = merchandiseMap[merchandiseId];
    if (!merchandiseItem) return [];

    if (merchandiseItem.pricingWrap.pricingType === 'TIERED') {
      return (merchandiseItem.pricingWrap.tieredPrices || []).map(function (_ref3) {
        var currencyCode = _ref3.currencyCode;
        return currencyCode;
      });
    }

    return (merchandiseItem.pricingWrap.prices || []).map(function (_ref4) {
      var currencyCode = _ref4.currencyCode;
      return currencyCode;
    });
  };

  return _arrayIntersection.default.apply(void 0, (0, _toConsumableArray2.default)(itemConfigurations.map(_getAvailableCurrencies)));
};

exports.availableCurrenciesAdapterV2 = exports.default = availableCurrenciesAdapter;